import BellFill from "~icons/eva/bell-fill"
import { _t } from "@cruisen/i18n"
import { CollaboratorJoinedTripNotificationData } from "@cruisen/contract"
import styles from "./styles.module.scss"

export const CollaboratorJoinedTrip = ({
  data,
}: {
  data: CollaboratorJoinedTripNotificationData
}) => (
  <div
    className={styles.container}
    //testID="navigator-message-collaborator-joined"
  >
    <BellFill className={styles.icon} />
    <p>{_t("notifications.collaboratorJoinedTrip.body", data)}</p>
  </div>
)
